import React, { useState } from 'react';
import { Grid, Button, FormControlLabel, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Export as ExportIcon } from '../../../../assets/icons/export';
import FilterDialog from '../../../../components/common/FilterButton/FilterDialog';
import PermissionChecker from '../../../../components/common/PermissionChecker';
import {
    STATUS_DRAFT_CHANGE_REQUESTED,
    STATUS_IN_DRAFT,
    STATUS_REQUISITION_APPROVED,
    TOTAL_POSITIONS,
} from '../../../../constants';
import { usePositionStatus } from '../../../../hooks/use-position-status';

const PositionTableActions = (props) => {
    const {
        filters,
        initialFilters,
        onFiltersApply,
        onFiltersClear,
        selectedPositions,
        filterProperties,
        action,
        readyForInternalHQOnly,
        onReadyForInternalHQChange,
        selectedStatus,
    } = props;
    const [positionStatuses] = usePositionStatus('preHQPositions');

    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const displayCheckBox = selectedStatus === STATUS_REQUISITION_APPROVED || selectedStatus === TOTAL_POSITIONS;

    const handleExport = () => {
        console.log('Export clicked');
    };

    const handleSendForApproval = () => {
        console.log('Sending positions for approval');
    };

    return (
        <>
            <Grid container spacing={1} direction="row-reverse" justifyContent="flex-start" alignItems="center" mb={2}>
                <PermissionChecker
                    requiredPermissions={['ROLE_BASE_PERMISSION_PRE_HQ_APPROVE_POSITIONS']}
                    noAuthRedirect={false}
                >
                    {positionStatuses?.every(
                        (status) => [STATUS_IN_DRAFT, STATUS_DRAFT_CHANGE_REQUESTED].indexOf(status) >= 0,
                    ) ? (
                        <Grid item alignContent="flex-end" xs="auto">
                            <Button color="primary" variant="contained" onClick={handleSendForApproval} size="medium">
                                Send for Approval
                            </Button>
                        </Grid>
                    ) : null}
                </PermissionChecker>
                <Grid item alignContent="flex-end" xs="auto">
                    <Button
                        color="primary"
                        disabled={false}
                        onClick={() => {
                            // setOpenFilterDialog(true);
                        }}
                        startIcon={<FilterAltIcon />}
                        size="medium"
                        variant={filters.length ? 'contained' : 'text'}
                    >
                        Filter
                    </Button>
                    <FilterDialog
                        onApply={onFiltersApply}
                        onClear={onFiltersClear}
                        onClose={() => setOpenFilterDialog(false)}
                        open={openFilterDialog}
                        operators={[]}
                        properties={filterProperties}
                        initialFilters={initialFilters}
                    />
                </Grid>
                <PermissionChecker
                    requiredPermissions={['ROLE_BASE_PERMISSION_PRE_HQ_EXPORT_POSITIONS']}
                    noAuthRedirect={false}
                >
                    <Grid item alignContent="flex-end" xs="auto">
                        <LoadingButton
                            color="secondary"
                            disabled={false}
                            onClick={handleExport}
                            size="medium"
                            variant="text"
                            startIcon={<ExportIcon fontSize="small" />}
                        >
                            Export
                        </LoadingButton>
                    </Grid>
                </PermissionChecker>
                {displayCheckBox && (
                    <Grid item alignContent="flex-end" xs="auto">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={readyForInternalHQOnly || false}
                                    onChange={(event) =>
                                        onReadyForInternalHQChange && onReadyForInternalHQChange(event.target.checked)
                                    }
                                    color="primary"
                                />
                            }
                            label="Ready for Internal HQ"
                            sx={{
                                ml: 2,
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                },
                            }}
                        />
                    </Grid>
                )}
            </Grid>
        </>
    );
};

export default PositionTableActions;
